module.exports = __webpack_public_path__ + "assets/bf9b21d28bf729fdd3c311d7256c6756.mp3";